import { BottomSheetIllustrationContent } from "@src/appV2/redesign/system/ui-components";
import Confetti from "react-confetti";

interface DocumentSubmissionApprovedBottomSheetContentProps {
  title?: string;
  description?: string;
  showConfetti?: boolean;
}

export function DocumentSubmissionApprovedBottomSheetContent(
  props: DocumentSubmissionApprovedBottomSheetContentProps
) {
  const { title = "Your document is approved!", description, showConfetti = true } = props;

  return (
    <>
      {showConfetti && (
        <Confetti
          recycle={false}
          width={window.innerWidth}
          height={window.innerHeight}
          numberOfPieces={200}
          gravity={0.4}
        />
      )}
      <BottomSheetIllustrationContent
        illustrationType="document-approved"
        title={title}
        description={description}
      />
    </>
  );
}
